<template>
  <el-dialog
    v-bind="$attrs"
    :ref="propRef"
    modal-class="base-dialog"
  >
    <template #header="{ close, titleId, titleClass }">
      <slot 
        name="header"
        :scope="{ close, titleId, titleClass }"
      >
      </slot>
    </template>
    <slot></slot>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>
<script lang="ts">
  import {
    defineComponent, PropType,
  } from 'vue';

  export default defineComponent({
    name: 'base-dialog',
    props: {
      /**
       * @description: ref值
       * @param {*} 默认lfDialog
       */
      propRef: {
        type: String,
        default: 'lfDialog',
      },
    },
  });
</script>
